export default __webpack_public_path__ + "static/media/logo-white.a8dc9bf8.svg";